(async function () {
  const el = document.getElementById("egift-data");
  if (!el) return;

  const currentTitle = el.dataset.title;
  const currentId = String(el.dataset.id);

  const normalize = (str) => str.replace(/\s+/g, "").toLowerCase();

  try {
    const res = await fetch(`/search?q=${encodeURIComponent(currentTitle)}&type=product`);
    const html = await res.text();

    const doc = new DOMParser().parseFromString(html, "text/html");

    const links = doc.querySelectorAll(".card__heading a, .full-unstyled-link");

    const checked = new Set();
    let count = 0;

    for (const link of links) {
      if (count > 20) break;
      count++;

      let url = link.getAttribute("href");
      if (!url) continue;

      url = new URL(url, window.location.origin).pathname;

      if (checked.has(url)) continue;
      checked.add(url);

      try {
        const productRes = await fetch(url + ".js");
        const productData = await productRes.json();

        if (normalize(productData.title) === normalize(currentTitle) && String(productData.id) !== currentId) {
          
          // HTMLを直接フェッチしてメタフィールドのラベルから判定する
          try {
            const htmlRes = await fetch(url);
            const htmlText = await htmlRes.text();
            const productDoc = new DOMParser().parseFromString(htmlText, "text/html");
            
            // 商品ページの中にある「アイコンメタフィールド」のテキストを抽出
            const iconLabels = productDoc.querySelectorAll('.a_card__label-list .a_card__label, .a_product__label-list .a_card__label');
            let hasEgiftIcon = false;
            iconLabels.forEach(label => {
              if (label.textContent.includes('eギフト') || label.textContent.includes('Eギフト')) {
                hasEgiftIcon = true;
              }
            });

            if (hasEgiftIcon) {
              const wrapper = document.getElementById("egift-nav-wrapper");
              const linkEl = document.getElementById("egift-nav-link");

              if (wrapper && linkEl) {
                linkEl.href = url;
                wrapper.style.display = "block";
              }
              return; // 見つかったら処理終了
            }
          } catch(e) {
            console.error("eGift HTML fetch error:", e);
          }
        }
      } catch (e) {
        // 個別商品のJSフェッチエラーは無視して次へ
      }
    }
  } catch (e) {
    console.error("eGift search error:", e);
  }
})();

// =============================================================================
// 商品ページ：注文上限（order_upper）注意表示・超過時はカート追加を無効化
// - カート側（a_cart.js）と同じ思想で「到達は注意」「超過は強い文言＋ボタン停止」
// - さらに商品ページでは data-cart-quantity が取れるので「残り上限（上限−カート内）」を実上限にする
// =============================================================================

document.addEventListener("DOMContentLoaded", () => {
  const toInt = (v) => {
    const n = parseInt(String(v ?? "").trim(), 10);
    return Number.isFinite(n) ? n : NaN;
  };

  // product-info.js が variant 更新後に toggleSubmitButton(false) し、フェッチHTMLに disabled が無いと
  // data-option-purchase-pause があっても押せてしまう。フラグ付きボタンは再び無効化する。
  const enforceOptionPurchasePause = () => {
    document.querySelectorAll('button[name="add"][data-option-purchase-pause="true"]').forEach((btn) => {
      btn.disabled = true;
    });
  };

  const syncProductQuantityLimit = (input) => {
    if (!input) return;

    const formEl = input.closest("form") || (input.getAttribute("form") ? document.getElementById(input.getAttribute("form")) : null);
    const scope = formEl || input.closest("product-form") || document;
    const addBtn = scope.querySelector('button[name="add"]');
    // buy-buttons.liquid：事前／事後掲載 or orderstopshoplist 停止時は Liquid が disabled を付与。数量同期で上書きしない
    const optionPurchasePause = addBtn?.dataset?.optionPurchasePause === "true";

    const limit = toInt(input.getAttribute("data-upper-limit"));
    const cartQty = Math.max(0, toInt(input.getAttribute("data-cart-quantity")) || 0);
    const val = Math.max(0, toInt(input.value));
    const hasCap = Number.isFinite(limit) && limit > 0;

    // 残り上限（0 未満にならないように丸め）
    const effectiveLimit = hasCap ? Math.max(limit - cartQty, 0) : NaN;

    // 表示要素（main-product.liquid 側で追加）
    const sectionId = input.id?.replace(/^Quantity-/, "") || "";
    const notice =
      document.getElementById(`ProductQuantityLimitNotice-${sectionId}`) ||
      scope.querySelector("[data-product-quantity-limit-notice]");

    // 上限がなければ何もしない（受付停止中はカートボタンを有効に戻さない）
    if (!hasCap || !notice) {
      if (addBtn && !optionPurchasePause) {
        addBtn.disabled = false;
        addBtn.removeAttribute("aria-disabled");
      }
      return;
    }

    // 表示条件：到達（>=）で注意、超過（>）で追加文言＋ボタン停止
    const show = val > 0 && val >= effectiveLimit && effectiveLimit > 0;
    const over = val > effectiveLimit && effectiveLimit >= 0;

    notice.style.display = show ? "block" : "none";

    // 文言差し込み
    const titleSpan = notice.querySelector(".error-product-title");
    const limitSpan = notice.querySelector(".error-upper-limit");
    if (titleSpan) titleSpan.textContent = input.getAttribute("data-product-title") || "";
    if (limitSpan) limitSpan.textContent = String(limit);

    // 超過時の追加文言
    const overMsg = notice.querySelector("[data-quantity-limit-over-message]");
    if (overMsg) overMsg.style.display = show && over ? "inline" : "none";

    // 入力上の max も「残り」に寄せる（通常はここで超過が発生しづらくなる）
    if (Number.isFinite(effectiveLimit) && effectiveLimit > 0) {
      input.max = String(effectiveLimit);
      input.dataset.max = String(effectiveLimit);
    }

    // 超過時だけカート追加を止める（到達は止めない）。受付停止中は disabled を触らない
    if (addBtn && !optionPurchasePause) {
      if (over) {
        addBtn.disabled = true;
        addBtn.setAttribute("aria-disabled", "true");
      } else {
        addBtn.disabled = false;
        addBtn.removeAttribute("aria-disabled");
      }
    }
  };

  // 数量同期より先に受付停止を確定（初回フレームで誤って有効化されないよう順序を固定）
  enforceOptionPurchasePause();

  // 初期同期（描画直後）
  document.querySelectorAll('input.quantity__input[name="quantity"][data-upper-limit]').forEach((input) => {
    syncProductQuantityLimit(input);
  });

  enforceOptionPurchasePause();
  [0, 50, 150].forEach((ms) => setTimeout(enforceOptionPurchasePause, ms));

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      requestAnimationFrame(enforceOptionPurchasePause);
    });
  }

  // テーマの <quantity-input>（global.js）は ± ボタンで値を変えたとき change のみ発火する（input は発火しない）
  const onQuantityMaybeChanged = (e) => {
    const t = e.target;
    if (!(t instanceof HTMLElement)) return;
    if (t.matches?.('input.quantity__input[name="quantity"][data-upper-limit]')) {
      syncProductQuantityLimit(t);
    }
  };
  document.addEventListener("input", onQuantityMaybeChanged);
  document.addEventListener("change", onQuantityMaybeChanged);
});

// =============================================================================
// 関連商品（a_related-products-new）：product-recommendations 反映後に Splide を初期化
// - product-recommendations が fetch で innerHTML を差し替えたあとにマウントする
// =============================================================================
(function () {
  if (typeof Splide === "undefined") return;

  const parseGap = (sectionEl) => {
    const n = parseInt(String(sectionEl?.dataset?.splideGap ?? "").trim(), 10);
    return Number.isFinite(n) ? n : 16;
  };

  function destroySplide(root) {
    const inst = root?._aRelatedProductsSplide;
    if (inst && typeof inst.destroy === "function") {
      try {
        inst.destroy(true);
      } catch (_) {}
    }
    if (root) root._aRelatedProductsSplide = null;
  }

  function mountSplide(sectionEl) {
    const root = sectionEl.querySelector("[data-related-products-splide-root]");
    if (!root || !root.querySelector(".splide__slide")) return;

    destroySplide(root);

    const gap = parseGap(sectionEl);
    const instance = new Splide(root, {
      type: "slide",
      gap,
      perMove: 1,
      omitEnd: true,
      pagination: false,
      arrows: false,
      drag: true,
      breakpoints: {
        989: { fixedWidth: 168 },
        9999: { fixedWidth: false },
      },
    });

    const bar = root.querySelector(".splide-carousel-progress-bar");
    if (bar) {
      instance.on("mounted move", () => {
        const end = instance.Components.Controller.getEnd() + 1;
        const rate = Math.min((instance.index + 1) / end, 1);
        bar.style.width = `${100 * rate}%`;
      });
    }

    instance.on("overflow", (isOverflow) => {
      instance.go(0);
      instance.options = { drag: isOverflow };
    });

    instance.mount();
    root._aRelatedProductsSplide = instance;

    const pr = sectionEl.querySelector("product-recommendations");
    if (pr && typeof window.reinitSwymWishlistButtons === "function") {
      window.reinitSwymWishlistButtons(pr);
    }
  }

  function teardownSection(sectionEl) {
    const root = sectionEl.querySelector("[data-related-products-splide-root]");
    if (root) destroySplide(root);
    if (sectionEl._aRelatedProductsObs) {
      sectionEl._aRelatedProductsObs.disconnect();
      sectionEl._aRelatedProductsObs = null;
    }
  }

  function setupSection(sectionEl) {
    teardownSection(sectionEl);

    const pr = sectionEl.querySelector("product-recommendations");
    if (!pr) return;

    const tryMount = () => {
      if (!pr.querySelector(".splide__slide")) return;
      mountSplide(sectionEl);
      if (sectionEl._aRelatedProductsObs) {
        sectionEl._aRelatedProductsObs.disconnect();
        sectionEl._aRelatedProductsObs = null;
      }
    };

    const obs = new MutationObserver(() => tryMount());
    obs.observe(pr, { childList: true, subtree: true });
    sectionEl._aRelatedProductsObs = obs;

    tryMount();
  }

  const initAll = () => {
    document.querySelectorAll("[data-a-related-products-new]").forEach((el) => setupSection(el));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (e) => {
    const block = e.target?.querySelector?.("[data-a-related-products-new]");
    if (!block) return;
    teardownSection(block);
    setupSection(block);
  });

  document.addEventListener("shopify:section:unload", (e) => {
    const block = e.target?.querySelector?.("[data-a-related-products-new]");
    if (!block) return;
    teardownSection(block);
  });
})();
